<p-menubar [model]="menuItems" />